import type {
  CreateVitaDocumentImportInput,
  CreateVitaCoverLetterInput,
} from '@xing-com/crate-common-graphql-types';

type CV = {
  [key: string]: any;
};

export const removeTypename = (obj: CV): CreateVitaDocumentImportInput => {
  const newObj: CreateVitaDocumentImportInput = JSON.parse(JSON.stringify(obj));
  removeTypenameRecursive(newObj);

  return newObj;
};

export const removeCoverLetterTypenameAndScrambledId = (
  obj: CV
): CreateVitaCoverLetterInput => {
  const newObj: CreateVitaCoverLetterInput = JSON.parse(JSON.stringify(obj));
  removeTypenameRecursive(newObj);
  removeScrambledIRecursive(newObj);

  return newObj;
};

// I hope that we can remove this after https://new-work.atlassian.net/browse/ACQ-1404
export const removeScrambledIRecursive = (obj: any): void => {
  for (const key in obj) {
    if (key === 'id') {
      obj[key] = obj[key].split('.')[0];
    } else if (typeof obj[key] === 'object' && obj[key] !== null) {
      removeScrambledIRecursive(obj[key]);
    }
  }
};

const removeTypenameRecursive = (obj: any): void => {
  for (const key in obj) {
    if (key === '__typename') {
      delete obj[key];
    } else if (typeof obj[key] === 'object' && obj[key] !== null) {
      removeTypenameRecursive(obj[key]);
    }
  }
};
